import { render, staticRenderFns } from "./mfa-password-reset.vue?vue&type=template&id=68dd80a2"
import script from "./mfa-password-reset.vue?vue&type=script&lang=js"
export * from "./mfa-password-reset.vue?vue&type=script&lang=js"
import style0 from "./mfa-password-reset.vue?vue&type=style&index=0&id=68dd80a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports